import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Select,
} from "@fluentui/react-components";
import React from "react";
import { contractTypeEnum } from "../../utils/enums";
import AppButton from "./AppButton";

interface IUserContractTypeDialogProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  contractType: number | null;
  onContractTypeChange: (value: number | null) => void;
  onSave: () => void;
  isLoading?: boolean;
}

const UserContractTypeDialog: React.FC<IUserContractTypeDialogProps> = ({
  open,
  setOpen,
  contractType,
  onContractTypeChange,
  onSave,
  isLoading,
}) => {
  return (
    <Dialog open={open} onOpenChange={(_, data) => setOpen(data.open)}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Zmień typ umowy</DialogTitle>
          <DialogContent>
            <div style={{ marginBottom: "8px", fontWeight: 600 }}>Typ umowy</div>
            <Select
              value={contractType === null ? "" : String(contractType)}
              onChange={(_, selectData) => {
                const value = selectData.value;
                onContractTypeChange(value === "" ? null : Number(value));
              }}
            >
              <option value="">Wybierz typ umowy</option>
              <option value={contractTypeEnum.B2B}>Umowa B2B</option>
              <option value={contractTypeEnum.EmploymentContract}>Umowa o pracę</option>
              <option value={contractTypeEnum.ContractOfMandate}>Umowa zlecenie</option>
            </Select>
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">Anuluj</Button>
            </DialogTrigger>
            <AppButton
              text="Zapisz"
              disabled={isLoading}
              appearance="primary"
              onClick={onSave}
            />
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default UserContractTypeDialog;
